module.exports = __webpack_public_path__ + "img/social.2114b9f9.svg";